import {
  GETCRITICALITYCOUNTFAILED,
  GETCRITICALITYCOUNT,
  SET_CRITICALITY_TYPE,
} from "../actions/CriticalityActions";

const initialState = {
  countObject: {},
  criticalityType: "2",
  isLoading: false,
  error: null,
};

export const criticalityReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETCRITICALITYCOUNT:
      return { ...state, countObject: action.payload };
    case GETCRITICALITYCOUNTFAILED:
      return { ...state, countObject: {} };
    case SET_CRITICALITY_TYPE:
      return { ...state, criticalityType: action.payload };
    default:
      return state;
  }
};
